module.exports = __webpack_public_path__ + "static/1-79a78a06079cff3074a323cdd70728ba.jpg";